<template>
  <div class="imgbox">
    <el-upload action="" :auto-upload=false :multiple="max==1?false:true" :file-list="imgList" :on-change="imgPreview" list-type="picture-card"
    accept="image/*" :limit="20" :disabled="delFlag" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
    :class="[isAdd?'hidden':'']"   drag>
      <slot></slot>
    </el-upload>
    <el-image-viewer v-if="dialogVisible" :on-close="closeViewer" :url-list="lookimgList" />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: { ElImageViewer },

  name: 'uploadImgs',
  props: {
    imgList: {
      type: Array,
      default: function () {
        return []
      }
    },

    max: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      lookimgList: [],
      dialogImageUrl: '',
      isAdd: false,
      dialogVisible: false,
      delFlag: false

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.imgList.length == this.max) {
      this.isAdd = true
    }
  },
  methods: {
    // 图片上传
    handleRemove (file, fileList) {
      this.$emit('update:imgList', fileList)
      this.$emit('remove', file)
      if (fileList.length < this.max) {
        this.isAdd = false
      }
      this.lookimgList = []
      fileList.forEach((item, index) => {
        this.$set(this.lookimgList, index, item.url)
      })
    },
    closeViewer () {
      this.dialogVisible = false
    },
    imgPreview (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png|)$/
      if (regex.test(fileName.toLowerCase())) {
        console.log(fileList, 'fileList')
        this.lookimgList = []
        fileList.forEach((item, index) => {
          this.$set(this.lookimgList, index, item.url)
        })
        this.$emit('update:imgList', fileList)
        this.$emit('change', fileList)
        if (fileList.length < this.max) {
          this.isAdd = false
        } else {
          this.isAdd = true
        }
      } else {
        fileList.pop()
        this.$alert('不支持此类型', '系统提示')
        return false
      }
    },
    handlePictureCardPreview (file) {
      if (this.lookimgList.length == 0) {
        this.imgList.forEach((item, index) => {
          this.lookimgList.push(item.url)
        })
        this.lookimgList.forEach((item, index) => {
          if (item == file.url) {
            this.lookimgList = this.lookimgList.slice(index).concat(this.lookimgList.slice(0, index))
            this.dialogVisible = true
          }
        })
      } else {
        this.lookimgList.forEach((item, index) => {
          if (item == file.url) {
            this.lookimgList = this.lookimgList.slice(index).concat(this.lookimgList.slice(0, index))
            this.dialogVisible = true
          }
        })
      }
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less' >
.imgbox{
  height: 100%;
  width: 100%;
}
.hidden {
  height: 100%;
  width: 100%;
}
/deep/.el-upload-list--picture-card {
  height: 100%;width: 100%;
}
.hidden /deep/.el-upload--picture-card {
  display: none;
}
/deep/.el-upload--picture-card{
  line-height: normal;
  height: 400px;
  width: 100%!important;
}
/deep/.el-upload-list--picture-card .el-upload-list__item{
  height: 100%!important;;
  width: 100%!important;;
}
/deep/.el-upload-dragger{
  background-color: transparent;
  border: none;
  height: 100%;width: 100%;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
}
</style>
